module.exports = __webpack_public_path__ + "static/media/bird3.6a186acc.jpg";